import { actions } from 'redux-rest-reducer';
import getGlobalHeaders from 'constants/headers';

export default actions({
  credentials: 'same-origin',
  headers: {
    ...getGlobalHeaders(),
  },
});
